<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>people</mat-icon></div>
          <mat-card-title>Clientes</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [showConsultarPor]="false"
          [showParametro]="true"
          labelParametro="ID"
          [(parametro)]="filtroId"
          parametroMask="separator.0"
          (consultar)="consultar()"
          (novo)="novo()">

          <div class="wow-consulta__campo wow-consulta__campo--wide">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Razão Social</mat-label>
              <input matInput [(ngModel)]="filtroRazaoSocial">
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>CNPJ</mat-label>
              <input matInput [(ngModel)]="filtroCnpj" mask="00.000.000/0000-00">
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Plano</mat-label>
              <mat-select [(ngModel)]="filtroPlano">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let p of planos" [value]="p.nome">{{ p.nome }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Segmento</mat-label>
              <mat-select [(ngModel)]="filtroSegmento">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let s of segmentos" [value]="s.codigo || s.nome">{{ s.nome }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Estado</mat-label>
              <mat-select [(ngModel)]="filtroEstado">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let e of estados" [value]="e">{{ e }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Colaborador responsável</mat-label>
              <mat-select [(ngModel)]="filtroColaboradorId">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let c of colaboradores" [value]="c.id">{{ c.nome }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo wow-consulta__campo--wide">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Cliente pagador</mat-label>
              <mat-select [(ngModel)]="filtroClientePagadorId">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let p of clientesPagadores" [value]="p.id">{{ p.razaoSocial }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe os filtros (opcional) e clique em <strong>Consultar</strong>.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="clients" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let client">{{ client.id }}</td>
            </ng-container>
            <ng-container matColumnDef="Razão Social">
              <th mat-header-cell *matHeaderCellDef>Razão Social</th>
              <td mat-cell *matCellDef="let client">{{ client.razaoSocial }}</td>
            </ng-container>
            <ng-container matColumnDef="documento">
              <th mat-header-cell *matHeaderCellDef>CNPJ</th>
              <td mat-cell *matCellDef="let client">{{ client.documento }}</td>
            </ng-container>
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let client">{{ client.estado }}</td>
            </ng-container>
            <ng-container matColumnDef="plano">
              <th mat-header-cell *matHeaderCellDef>Plano</th>
              <td mat-cell *matCellDef="let client">{{ client.plano }}</td>
            </ng-container>
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let client" (click)="$event.stopPropagation()">
                <button (click)="editar(client.id)" mat-icon-button color="accent" matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="openDialog(client.id)" mat-icon-button color="warn" matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
                <button (click)="prepararComodato(client.id)" mat-icon-button matTooltip="Comodato">
                  <mat-icon>handshake</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>
          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)"></mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
